// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.3.0 (commit aa73d1c35b4b346b98eeba10a3d756b4ae72162f).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AddDirtyPileReducer from "./add_dirty_pile_reducer";
import AddFavoriteReducer from "./add_favorite_reducer";
import AdminAdjustMoneyReducer from "./admin_adjust_money_reducer";
import AdminAnnounceCriticReducer from "./admin_announce_critic_reducer";
import AdminBanPlayerReducer from "./admin_ban_player_reducer";
import AdminBumpResetGenerationReducer from "./admin_bump_reset_generation_reducer";
import AdminDeleteRestaurantReducer from "./admin_delete_restaurant_reducer";
import AdminReleaseBuildingReducer from "./admin_release_building_reducer";
import AdminResetCrateReducer from "./admin_reset_crate_reducer";
import AdminResetPasswordReducer from "./admin_reset_password_reducer";
import AdminResolveFeedbackReducer from "./admin_resolve_feedback_reducer";
import AdminSetMoneyReducer from "./admin_set_money_reducer";
import AdminSetWeatherReducer from "./admin_set_weather_reducer";
import AdminSpawnVipReducer from "./admin_spawn_vip_reducer";
import AdminUnbanPlayerReducer from "./admin_unban_player_reducer";
import BootstrapChatScheduleReducer from "./bootstrap_chat_schedule_reducer";
import BootstrapCityReducer from "./bootstrap_city_reducer";
import BootstrapPedestrianScheduleReducer from "./bootstrap_pedestrian_schedule_reducer";
import BootstrapSeasonStampsReducer from "./bootstrap_season_stamps_reducer";
import BootstrapSimSchedulesReducer from "./bootstrap_sim_schedules_reducer";
import BootstrapWeatherReducer from "./bootstrap_weather_reducer";
import BootstrapWorldEventsReducer from "./bootstrap_world_events_reducer";
import BumpCloudMoneyReducer from "./bump_cloud_money_reducer";
import BumpDishwarePoolReducer from "./bump_dishware_pool_reducer";
import BumpPantryStockReducer from "./bump_pantry_stock_reducer";
import BusSeatReducer from "./bus_seat_reducer";
import CancelRecipeUpgradeReducer from "./cancel_recipe_upgrade_reducer";
import CancelTicketReducer from "./cancel_ticket_reducer";
import ChargeRentReducer from "./charge_rent_reducer";
import ClaimAchievementReducer from "./claim_achievement_reducer";
import ClaimBuildingReducer from "./claim_building_reducer";
import ClaimDailyGoalReducer from "./claim_daily_goal_reducer";
import ClaimDirtyPileReducer from "./claim_dirty_pile_reducer";
import ClaimLowBalanceGrantReducer from "./claim_low_balance_grant_reducer";
import ClaimRecycleReducer from "./claim_recycle_reducer";
import ClaimStarterGrantReducer from "./claim_starter_grant_reducer";
import ClaimSupplyCrateReducer from "./claim_supply_crate_reducer";
import ClaimTicketReducer from "./claim_ticket_reducer";
import ClaimTipBonusReducer from "./claim_tip_bonus_reducer";
import ClearWaiterRestSpotReducer from "./clear_waiter_rest_spot_reducer";
import CollectClueReducer from "./collect_clue_reducer";
import ConsumePendingDayAdvancementReducer from "./consume_pending_day_advancement_reducer";
import ConsumePendingRecipeUpgradesReducer from "./consume_pending_recipe_upgrades_reducer";
import ConsumePendingRestockCostReducer from "./consume_pending_restock_cost_reducer";
import ConsumePendingSalaryReducer from "./consume_pending_salary_reducer";
import ConsumePendingTrainingCompletionsReducer from "./consume_pending_training_completions_reducer";
import ConsumePendingVisitRollupReducer from "./consume_pending_visit_rollup_reducer";
import CreateRestaurantReducer from "./create_restaurant_reducer";
import DeleteGuestbookEntryReducer from "./delete_guestbook_entry_reducer";
import DeleteHiredStaffMemberReducer from "./delete_hired_staff_member_reducer";
import DeleteLayoutPresetReducer from "./delete_layout_preset_reducer";
import DeleteRestaurantReducer from "./delete_restaurant_reducer";
import DeliverTicketReducer from "./deliver_ticket_reducer";
import FinishCookingReducer from "./finish_cooking_reducer";
import GreetGuestReducer from "./greet_guest_reducer";
import InviteCoOwnerReducer from "./invite_co_owner_reducer";
import LoginReducer from "./login_reducer";
import LogoutReducer from "./logout_reducer";
import MarkGuestDishesSettledReducer from "./mark_guest_dishes_settled_reducer";
import MarkGuestLeavingReducer from "./mark_guest_leaving_reducer";
import MoveFurnitureReducer from "./move_furniture_reducer";
import PickupDirtyPileReducer from "./pickup_dirty_pile_reducer";
import PickupDirtyPileBySeatReducer from "./pickup_dirty_pile_by_seat_reducer";
import PickupTicketReducer from "./pickup_ticket_reducer";
import PingPresenceReducer from "./ping_presence_reducer";
import PlaceFromInventoryReducer from "./place_from_inventory_reducer";
import PlaceFurnitureReducer from "./place_furniture_reducer";
import PlaceOrderReducer from "./place_order_reducer";
import ProcessSeasonResetReducer from "./process_season_reset_reducer";
import PublishPlayerSaveReducer from "./publish_player_save_reducer";
import ReactToRestaurantReducer from "./react_to_restaurant_reducer";
import RecordVisitReducer from "./record_visit_reducer";
import RefreshNeighborhoodReducer from "./refresh_neighborhood_reducer";
import RegisterStaffActorReducer from "./register_staff_actor_reducer";
import ReleaseDirtyPileReducer from "./release_dirty_pile_reducer";
import RemoveCoOwnerReducer from "./remove_co_owner_reducer";
import RemoveFavoriteReducer from "./remove_favorite_reducer";
import ReplaceSeatSlotsReducer from "./replace_seat_slots_reducer";
import RequestPasswordResetReducer from "./request_password_reset_reducer";
import ResetSalaryTickClockReducer from "./reset_salary_tick_clock_reducer";
import ResetSimSchedulesReducer from "./reset_sim_schedules_reducer";
import RespondFriendRequestReducer from "./respond_friend_request_reducer";
import ReviewRestaurantReducer from "./review_restaurant_reducer";
import SaveAccountReducer from "./save_account_reducer";
import SaveLayoutPresetReducer from "./save_layout_preset_reducer";
import SaveRestaurantSnapshotReducer from "./save_restaurant_snapshot_reducer";
import SellDishwareReducer from "./sell_dishware_reducer";
import SellFurnitureReducer from "./sell_furniture_reducer";
import SellPantryStockReducer from "./sell_pantry_stock_reducer";
import SendChatGlobalReducer from "./send_chat_global_reducer";
import SendChatPrivateReducer from "./send_chat_private_reducer";
import SendFriendRequestReducer from "./send_friend_request_reducer";
import SetActiveMenuReducer from "./set_active_menu_reducer";
import SetAutoShopEnabledReducer from "./set_auto_shop_enabled_reducer";
import SetBoostExpiresAtReducer from "./set_boost_expires_at_reducer";
import SetCloudDayHistoryReducer from "./set_cloud_day_history_reducer";
import SetCloudMoneyReducer from "./set_cloud_money_reducer";
import SetCloudPayrollRateReducer from "./set_cloud_payroll_rate_reducer";
import SetCloudRatingHistoryReducer from "./set_cloud_rating_history_reducer";
import SetCloudTransactionLogReducer from "./set_cloud_transaction_log_reducer";
import SetCustomerArchetypeReducer from "./set_customer_archetype_reducer";
import SetErrandStateReducer from "./set_errand_state_reducer";
import SetFurnitureCostReducer from "./set_furniture_cost_reducer";
import SetFurnitureMetaReducer from "./set_furniture_meta_reducer";
import SetGuestOrderReducer from "./set_guest_order_reducer";
import SetGuestReservedTiersReducer from "./set_guest_reserved_tiers_reducer";
import SetGuestWaitingChairReducer from "./set_guest_waiting_chair_reducer";
import SetHiredStaffMemberReducer from "./set_hired_staff_member_reducer";
import SetIngredientCostReducer from "./set_ingredient_cost_reducer";
import SetMemberTrainingDeadlineReducer from "./set_member_training_deadline_reducer";
import SetMoneyCutoverActiveReducer from "./set_money_cutover_active_reducer";
import SetPantryTargetReducer from "./set_pantry_target_reducer";
import SetPlayerNameReducer from "./set_player_name_reducer";
import SetPreparedServingReducer from "./set_prepared_serving_reducer";
import SetRecipeIngredientsReducer from "./set_recipe_ingredients_reducer";
import SetRecipeLevelReducer from "./set_recipe_level_reducer";
import SetRecipeMetaReducer from "./set_recipe_meta_reducer";
import SetRestaurantNameReducer from "./set_restaurant_name_reducer";
import SetRestaurantPublicReducer from "./set_restaurant_public_reducer";
import SetRestaurantSignStyleReducer from "./set_restaurant_sign_style_reducer";
import SetRestaurantThemeOverridesReducer from "./set_restaurant_theme_overrides_reducer";
import SetWaiterRestSpotReducer from "./set_waiter_rest_spot_reducer";
import SignGuestbookReducer from "./sign_guestbook_reducer";
import SignUpReducer from "./sign_up_reducer";
import SpawnGuestReducer from "./spawn_guest_reducer";
import StartRecipeUpgradeReducer from "./start_recipe_upgrade_reducer";
import StirTicketReducer from "./stir_ticket_reducer";
import StoreFurnitureReducer from "./store_furniture_reducer";
import SubmitFeedbackReducer from "./submit_feedback_reducer";
import SubmitLeaderboardReducer from "./submit_leaderboard_reducer";
import SyncCloudDailyTotalsReducer from "./sync_cloud_daily_totals_reducer";
import SyncDayClockReducer from "./sync_day_clock_reducer";
import UnfriendReducer from "./unfriend_reducer";
import UnlockAchievementReducer from "./unlock_achievement_reducer";
import UnregisterStaffActorReducer from "./unregister_staff_actor_reducer";
import UpdateDishwarePoolReducer from "./update_dishware_pool_reducer";
import UpdateDishwasherBatchReducer from "./update_dishwasher_batch_reducer";
import UpdateGuestPositionReducer from "./update_guest_position_reducer";
import UpdateRestaurantAggregatesReducer from "./update_restaurant_aggregates_reducer";
import UpdateStaffActorReducer from "./update_staff_actor_reducer";
import WipeMyRestaurantReducer from "./wipe_my_restaurant_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AccountSaveRow from "./account_save_table";
import AchievementUnlockRow from "./achievement_unlock_table";
import ActiveGuestRow from "./active_guest_table";
import ActiveMenuRow from "./active_menu_table";
import ActiveTicketRow from "./active_ticket_table";
import AuthRecordRow from "./auth_record_table";
import BanRecordRow from "./ban_record_table";
import BuildingRow from "./building_table";
import ChatMessageRow from "./chat_message_table";
import ClueHuntRow from "./clue_hunt_table";
import CoOwnerRow from "./co_owner_table";
import CustomerArchetypeRow from "./customer_archetype_table";
import DailyGoalStateRow from "./daily_goal_state_table";
import DirtyPileRow from "./dirty_pile_table";
import DishwarePoolRow from "./dishware_pool_table";
import DishwasherBatchRow from "./dishwasher_batch_table";
import FavoriteRow from "./favorite_table";
import FeedbackRow from "./feedback_table";
import FriendRequestRow from "./friend_request_table";
import FriendshipRow from "./friendship_table";
import FurnitureCostRow from "./furniture_cost_table";
import FurnitureInventoryRow from "./furniture_inventory_table";
import FurnitureMetaRow from "./furniture_meta_table";
import GameResetRow from "./game_reset_table";
import GuestbookEntryRow from "./guestbook_entry_table";
import HiredStaffMemberRow from "./hired_staff_member_table";
import IngredientCostRow from "./ingredient_cost_table";
import LayoutPresetRow from "./layout_preset_table";
import LeaderboardEntryRow from "./leaderboard_entry_table";
import MoneyCutoverRow from "./money_cutover_table";
import MoneyEventRow from "./money_event_table";
import NeighborhoodSlotRow from "./neighborhood_slot_table";
import PantryStockRow from "./pantry_stock_table";
import PantryTargetRow from "./pantry_target_table";
import PasswordResetRequestRow from "./password_reset_request_table";
import PedestrianRow from "./pedestrian_table";
import PlacedFurnitureRow from "./placed_furniture_table";
import PlayerRow from "./player_table";
import PlayerSaveRow from "./player_save_table";
import PreparedServingRow from "./prepared_serving_table";
import RecipeIngredientsRow from "./recipe_ingredients_table";
import RecipeLevelRow from "./recipe_level_table";
import RecipeMetaRow from "./recipe_meta_table";
import RecipeUpgradeInFlightRow from "./recipe_upgrade_in_flight_table";
import RegularCustomerRow from "./regular_customer_table";
import RestaurantRow from "./restaurant_table";
import RestaurantReviewRow from "./restaurant_review_table";
import RestaurantTickStateRow from "./restaurant_tick_state_table";
import SaveSnapshotRow from "./save_snapshot_table";
import SeatAppealRow from "./seat_appeal_table";
import SeatSlotRow from "./seat_slot_table";
import StaffActorRow from "./staff_actor_table";
import StaffStatRow from "./staff_stat_table";
import StatSnapshotRow from "./stat_snapshot_table";
import VisitEventRow from "./visit_event_table";
import VisitReactionRow from "./visit_reaction_table";
import WeatherStateRow from "./weather_state_table";
import WorldEventRow from "./world_event_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  account_save: __table({
    name: 'account_save',
    indexes: [
      { accessor: 'username', name: 'account_save_username_idx_btree', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'account_save_username_key', constraint: 'unique', columns: ['username'] },
    ],
  }, AccountSaveRow),
  achievement_unlock: __table({
    name: 'achievement_unlock',
    indexes: [
      { accessor: 'id', name: 'achievement_unlock_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player', name: 'achievement_unlock_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
    ],
    constraints: [
      { name: 'achievement_unlock_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AchievementUnlockRow),
  active_guest: __table({
    name: 'active_guest',
    indexes: [
      { accessor: 'client_temp_id', name: 'active_guest_client_temp_id_idx_btree', algorithm: 'btree', columns: [
        'clientTempId',
      ] },
      { accessor: 'id', name: 'active_guest_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'active_guest_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'active_guest_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ActiveGuestRow),
  active_menu: __table({
    name: 'active_menu',
    indexes: [
      { accessor: 'restaurant_id', name: 'active_menu_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'active_menu_restaurant_id_key', constraint: 'unique', columns: ['restaurantId'] },
    ],
  }, ActiveMenuRow),
  active_ticket: __table({
    name: 'active_ticket',
    indexes: [
      { accessor: 'client_temp_id', name: 'active_ticket_client_temp_id_idx_btree', algorithm: 'btree', columns: [
        'clientTempId',
      ] },
      { accessor: 'guest_id', name: 'active_ticket_guest_id_idx_btree', algorithm: 'btree', columns: [
        'guestId',
      ] },
      { accessor: 'id', name: 'active_ticket_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'active_ticket_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'active_ticket_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ActiveTicketRow),
  auth_record: __table({
    name: 'auth_record',
    indexes: [
      { accessor: 'identity', name: 'auth_record_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'username', name: 'auth_record_username_idx_btree', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'auth_record_username_key', constraint: 'unique', columns: ['username'] },
    ],
  }, AuthRecordRow),
  ban_record: __table({
    name: 'ban_record',
    indexes: [
      { accessor: 'username', name: 'ban_record_username_idx_btree', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'ban_record_username_key', constraint: 'unique', columns: ['username'] },
    ],
  }, BanRecordRow),
  building: __table({
    name: 'building',
    indexes: [
      { accessor: 'id', name: 'building_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner_identity', name: 'building_owner_identity_idx_btree', algorithm: 'btree', columns: [
        'ownerIdentity',
      ] },
    ],
    constraints: [
      { name: 'building_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BuildingRow),
  chat_message: __table({
    name: 'chat_message',
    indexes: [
      { accessor: 'channel', name: 'chat_message_channel_idx_btree', algorithm: 'btree', columns: [
        'channel',
      ] },
      { accessor: 'id', name: 'chat_message_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'sender', name: 'chat_message_sender_idx_btree', algorithm: 'btree', columns: [
        'sender',
      ] },
    ],
    constraints: [
      { name: 'chat_message_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ChatMessageRow),
  clue_hunt: __table({
    name: 'clue_hunt',
    indexes: [
      { accessor: 'identity', name: 'clue_hunt_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'clue_hunt_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ClueHuntRow),
  co_owner: __table({
    name: 'co_owner',
    indexes: [
      { accessor: 'id', name: 'co_owner_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player', name: 'co_owner_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'restaurant_id', name: 'co_owner_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'co_owner_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CoOwnerRow),
  customer_archetype: __table({
    name: 'customer_archetype',
    indexes: [
      { accessor: 'archetype_id', name: 'customer_archetype_archetype_id_idx_btree', algorithm: 'btree', columns: [
        'archetypeId',
      ] },
    ],
    constraints: [
      { name: 'customer_archetype_archetype_id_key', constraint: 'unique', columns: ['archetypeId'] },
    ],
  }, CustomerArchetypeRow),
  daily_goal_state: __table({
    name: 'daily_goal_state',
    indexes: [
      { accessor: 'restaurant_id', name: 'daily_goal_state_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'daily_goal_state_restaurant_id_key', constraint: 'unique', columns: ['restaurantId'] },
    ],
  }, DailyGoalStateRow),
  dirty_pile: __table({
    name: 'dirty_pile',
    indexes: [
      { accessor: 'id', name: 'dirty_pile_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'dirty_pile_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'dirty_pile_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DirtyPileRow),
  dishware_pool: __table({
    name: 'dishware_pool',
    indexes: [
      { accessor: 'key', name: 'dishware_pool_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'restaurant_id', name: 'dishware_pool_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'dishware_pool_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, DishwarePoolRow),
  dishwasher_batch: __table({
    name: 'dishwasher_batch',
    indexes: [
      { accessor: 'furniture_uid', name: 'dishwasher_batch_furniture_uid_idx_btree', algorithm: 'btree', columns: [
        'furnitureUid',
      ] },
      { accessor: 'restaurant_id', name: 'dishwasher_batch_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'dishwasher_batch_furniture_uid_key', constraint: 'unique', columns: ['furnitureUid'] },
    ],
  }, DishwasherBatchRow),
  favorite: __table({
    name: 'favorite',
    indexes: [
      { accessor: 'id', name: 'favorite_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player', name: 'favorite_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'restaurant_id', name: 'favorite_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'favorite_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FavoriteRow),
  feedback: __table({
    name: 'feedback',
    indexes: [
      { accessor: 'id', name: 'feedback_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'identity', name: 'feedback_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'feedback_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FeedbackRow),
  friend_request: __table({
    name: 'friend_request',
    indexes: [
      { accessor: 'from_player', name: 'friend_request_from_player_idx_btree', algorithm: 'btree', columns: [
        'fromPlayer',
      ] },
      { accessor: 'id', name: 'friend_request_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'to_player', name: 'friend_request_to_player_idx_btree', algorithm: 'btree', columns: [
        'toPlayer',
      ] },
    ],
    constraints: [
      { name: 'friend_request_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FriendRequestRow),
  friendship: __table({
    name: 'friendship',
    indexes: [
      { accessor: 'id', name: 'friendship_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player_a', name: 'friendship_player_a_idx_btree', algorithm: 'btree', columns: [
        'playerA',
      ] },
      { accessor: 'player_b', name: 'friendship_player_b_idx_btree', algorithm: 'btree', columns: [
        'playerB',
      ] },
    ],
    constraints: [
      { name: 'friendship_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FriendshipRow),
  furniture_cost: __table({
    name: 'furniture_cost',
    indexes: [
      { accessor: 'def_id', name: 'furniture_cost_def_id_idx_btree', algorithm: 'btree', columns: [
        'defId',
      ] },
    ],
    constraints: [
      { name: 'furniture_cost_def_id_key', constraint: 'unique', columns: ['defId'] },
    ],
  }, FurnitureCostRow),
  furniture_inventory: __table({
    name: 'furniture_inventory',
    indexes: [
      { accessor: 'id', name: 'furniture_inventory_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'furniture_inventory_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'furniture_inventory_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FurnitureInventoryRow),
  furniture_meta: __table({
    name: 'furniture_meta',
    indexes: [
      { accessor: 'def_id', name: 'furniture_meta_def_id_idx_btree', algorithm: 'btree', columns: [
        'defId',
      ] },
    ],
    constraints: [
      { name: 'furniture_meta_def_id_key', constraint: 'unique', columns: ['defId'] },
    ],
  }, FurnitureMetaRow),
  game_reset: __table({
    name: 'game_reset',
    indexes: [
      { accessor: 'id', name: 'game_reset_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'game_reset_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GameResetRow),
  guestbook_entry: __table({
    name: 'guestbook_entry',
    indexes: [
      { accessor: 'author', name: 'guestbook_entry_author_idx_btree', algorithm: 'btree', columns: [
        'author',
      ] },
      { accessor: 'id', name: 'guestbook_entry_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'target_owner', name: 'guestbook_entry_target_owner_idx_btree', algorithm: 'btree', columns: [
        'targetOwner',
      ] },
    ],
    constraints: [
      { name: 'guestbook_entry_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GuestbookEntryRow),
  hired_staff_member: __table({
    name: 'hired_staff_member',
    indexes: [
      { accessor: 'member_id', name: 'hired_staff_member_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
      { accessor: 'restaurant_id', name: 'hired_staff_member_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'hired_staff_member_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, HiredStaffMemberRow),
  ingredient_cost: __table({
    name: 'ingredient_cost',
    indexes: [
      { accessor: 'ingredient_id', name: 'ingredient_cost_ingredient_id_idx_btree', algorithm: 'btree', columns: [
        'ingredientId',
      ] },
    ],
    constraints: [
      { name: 'ingredient_cost_ingredient_id_key', constraint: 'unique', columns: ['ingredientId'] },
    ],
  }, IngredientCostRow),
  layout_preset: __table({
    name: 'layout_preset',
    indexes: [
      { accessor: 'id', name: 'layout_preset_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'layout_preset_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'layout_preset_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LayoutPresetRow),
  leaderboard_entry: __table({
    name: 'leaderboard_entry',
    indexes: [
      { accessor: 'category', name: 'leaderboard_entry_category_idx_btree', algorithm: 'btree', columns: [
        'category',
      ] },
      { accessor: 'id', name: 'leaderboard_entry_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'player', name: 'leaderboard_entry_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
    ],
    constraints: [
      { name: 'leaderboard_entry_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LeaderboardEntryRow),
  money_cutover: __table({
    name: 'money_cutover',
    indexes: [
      { accessor: 'id', name: 'money_cutover_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'money_cutover_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MoneyCutoverRow),
  money_event: __table({
    name: 'money_event',
    indexes: [
      { accessor: 'id', name: 'money_event_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'money_event_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'money_event_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, MoneyEventRow),
  neighborhood_slot: __table({
    name: 'neighborhood_slot',
    indexes: [
      { accessor: 'id', name: 'neighborhood_slot_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'viewer', name: 'neighborhood_slot_viewer_idx_btree', algorithm: 'btree', columns: [
        'viewer',
      ] },
    ],
    constraints: [
      { name: 'neighborhood_slot_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, NeighborhoodSlotRow),
  pantry_stock: __table({
    name: 'pantry_stock',
    indexes: [
      { accessor: 'key', name: 'pantry_stock_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'restaurant_id', name: 'pantry_stock_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'pantry_stock_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, PantryStockRow),
  pantry_target: __table({
    name: 'pantry_target',
    indexes: [
      { accessor: 'restaurant_id', name: 'pantry_target_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'pantry_target_restaurant_id_key', constraint: 'unique', columns: ['restaurantId'] },
    ],
  }, PantryTargetRow),
  password_reset_request: __table({
    name: 'password_reset_request',
    indexes: [
      { accessor: 'id', name: 'password_reset_request_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'username', name: 'password_reset_request_username_idx_btree', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'password_reset_request_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PasswordResetRequestRow),
  pedestrian: __table({
    name: 'pedestrian',
    indexes: [
      { accessor: 'id', name: 'pedestrian_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'pedestrian_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PedestrianRow),
  placed_furniture: __table({
    name: 'placed_furniture',
    indexes: [
      { accessor: 'restaurant_id', name: 'placed_furniture_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
      { accessor: 'uid', name: 'placed_furniture_uid_idx_btree', algorithm: 'btree', columns: [
        'uid',
      ] },
    ],
    constraints: [
      { name: 'placed_furniture_uid_key', constraint: 'unique', columns: ['uid'] },
    ],
  }, PlacedFurnitureRow),
  player: __table({
    name: 'player',
    indexes: [
      { accessor: 'identity', name: 'player_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerRow),
  player_save: __table({
    name: 'player_save',
    indexes: [
      { accessor: 'identity', name: 'player_save_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_save_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerSaveRow),
  prepared_serving: __table({
    name: 'prepared_serving',
    indexes: [
      { accessor: 'key', name: 'prepared_serving_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'restaurant_id', name: 'prepared_serving_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'prepared_serving_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, PreparedServingRow),
  recipe_ingredients: __table({
    name: 'recipe_ingredients',
    indexes: [
      { accessor: 'recipe_id', name: 'recipe_ingredients_recipe_id_idx_btree', algorithm: 'btree', columns: [
        'recipeId',
      ] },
    ],
    constraints: [
      { name: 'recipe_ingredients_recipe_id_key', constraint: 'unique', columns: ['recipeId'] },
    ],
  }, RecipeIngredientsRow),
  recipe_level: __table({
    name: 'recipe_level',
    indexes: [
      { accessor: 'key', name: 'recipe_level_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'restaurant_id', name: 'recipe_level_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'recipe_level_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, RecipeLevelRow),
  recipe_meta: __table({
    name: 'recipe_meta',
    indexes: [
      { accessor: 'recipe_id', name: 'recipe_meta_recipe_id_idx_btree', algorithm: 'btree', columns: [
        'recipeId',
      ] },
    ],
    constraints: [
      { name: 'recipe_meta_recipe_id_key', constraint: 'unique', columns: ['recipeId'] },
    ],
  }, RecipeMetaRow),
  recipe_upgrade_in_flight: __table({
    name: 'recipe_upgrade_in_flight',
    indexes: [
      { accessor: 'key', name: 'recipe_upgrade_in_flight_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'restaurant_id', name: 'recipe_upgrade_in_flight_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'recipe_upgrade_in_flight_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, RecipeUpgradeInFlightRow),
  regular_customer: __table({
    name: 'regular_customer',
    indexes: [
      { accessor: 'id', name: 'regular_customer_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'regular_customer_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'regular_customer_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RegularCustomerRow),
  restaurant: __table({
    name: 'restaurant',
    indexes: [
      { accessor: 'id', name: 'restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'owner', name: 'restaurant_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'restaurant_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RestaurantRow),
  restaurant_review: __table({
    name: 'restaurant_review',
    indexes: [
      { accessor: 'id', name: 'restaurant_review_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'reviewer', name: 'restaurant_review_reviewer_idx_btree', algorithm: 'btree', columns: [
        'reviewer',
      ] },
      { accessor: 'target_owner', name: 'restaurant_review_target_owner_idx_btree', algorithm: 'btree', columns: [
        'targetOwner',
      ] },
    ],
    constraints: [
      { name: 'restaurant_review_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RestaurantReviewRow),
  restaurant_tick_state: __table({
    name: 'restaurant_tick_state',
    indexes: [
      { accessor: 'restaurant_id', name: 'restaurant_tick_state_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'restaurant_tick_state_restaurant_id_key', constraint: 'unique', columns: ['restaurantId'] },
    ],
  }, RestaurantTickStateRow),
  save_snapshot: __table({
    name: 'save_snapshot',
    indexes: [
      { accessor: 'restaurant_id', name: 'save_snapshot_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'save_snapshot_restaurant_id_key', constraint: 'unique', columns: ['restaurantId'] },
    ],
  }, SaveSnapshotRow),
  seat_appeal: __table({
    name: 'seat_appeal',
    indexes: [
      { accessor: 'restaurant_id', name: 'seat_appeal_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
      { accessor: 'seat_uid', name: 'seat_appeal_seat_uid_idx_btree', algorithm: 'btree', columns: [
        'seatUid',
      ] },
    ],
    constraints: [
      { name: 'seat_appeal_seat_uid_key', constraint: 'unique', columns: ['seatUid'] },
    ],
  }, SeatAppealRow),
  seat_slot: __table({
    name: 'seat_slot',
    indexes: [
      { accessor: 'restaurant_id', name: 'seat_slot_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
      { accessor: 'seat_uid', name: 'seat_slot_seat_uid_idx_btree', algorithm: 'btree', columns: [
        'seatUid',
      ] },
    ],
    constraints: [
      { name: 'seat_slot_seat_uid_key', constraint: 'unique', columns: ['seatUid'] },
    ],
  }, SeatSlotRow),
  staff_actor: __table({
    name: 'staff_actor',
    indexes: [
      { accessor: 'member_id', name: 'staff_actor_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
      { accessor: 'restaurant_id', name: 'staff_actor_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'staff_actor_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, StaffActorRow),
  staff_stat: __table({
    name: 'staff_stat',
    indexes: [
      { accessor: 'id', name: 'staff_stat_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'staff_stat_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'staff_stat_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, StaffStatRow),
  stat_snapshot: __table({
    name: 'stat_snapshot',
    indexes: [
      { accessor: 'id', name: 'stat_snapshot_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'restaurant_id', name: 'stat_snapshot_restaurant_id_idx_btree', algorithm: 'btree', columns: [
        'restaurantId',
      ] },
    ],
    constraints: [
      { name: 'stat_snapshot_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, StatSnapshotRow),
  visit_event: __table({
    name: 'visit_event',
    indexes: [
      { accessor: 'host', name: 'visit_event_host_idx_btree', algorithm: 'btree', columns: [
        'host',
      ] },
      { accessor: 'id', name: 'visit_event_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'visitor', name: 'visit_event_visitor_idx_btree', algorithm: 'btree', columns: [
        'visitor',
      ] },
    ],
    constraints: [
      { name: 'visit_event_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VisitEventRow),
  visit_reaction: __table({
    name: 'visit_reaction',
    indexes: [
      { accessor: 'id', name: 'visit_reaction_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'reactor', name: 'visit_reaction_reactor_idx_btree', algorithm: 'btree', columns: [
        'reactor',
      ] },
      { accessor: 'target_owner', name: 'visit_reaction_target_owner_idx_btree', algorithm: 'btree', columns: [
        'targetOwner',
      ] },
    ],
    constraints: [
      { name: 'visit_reaction_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VisitReactionRow),
  weather_state: __table({
    name: 'weather_state',
    indexes: [
      { accessor: 'id', name: 'weather_state_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'weather_state_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WeatherStateRow),
  world_event: __table({
    name: 'world_event',
    indexes: [
      { accessor: 'id', name: 'world_event_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'world_event_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WorldEventRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_dirty_pile", AddDirtyPileReducer),
  __reducerSchema("add_favorite", AddFavoriteReducer),
  __reducerSchema("admin_adjust_money", AdminAdjustMoneyReducer),
  __reducerSchema("admin_announce_critic", AdminAnnounceCriticReducer),
  __reducerSchema("admin_ban_player", AdminBanPlayerReducer),
  __reducerSchema("admin_bump_reset_generation", AdminBumpResetGenerationReducer),
  __reducerSchema("admin_delete_restaurant", AdminDeleteRestaurantReducer),
  __reducerSchema("admin_release_building", AdminReleaseBuildingReducer),
  __reducerSchema("admin_reset_crate", AdminResetCrateReducer),
  __reducerSchema("admin_reset_password", AdminResetPasswordReducer),
  __reducerSchema("admin_resolve_feedback", AdminResolveFeedbackReducer),
  __reducerSchema("admin_set_money", AdminSetMoneyReducer),
  __reducerSchema("admin_set_weather", AdminSetWeatherReducer),
  __reducerSchema("admin_spawn_vip", AdminSpawnVipReducer),
  __reducerSchema("admin_unban_player", AdminUnbanPlayerReducer),
  __reducerSchema("bootstrap_chat_schedule", BootstrapChatScheduleReducer),
  __reducerSchema("bootstrap_city", BootstrapCityReducer),
  __reducerSchema("bootstrap_pedestrian_schedule", BootstrapPedestrianScheduleReducer),
  __reducerSchema("bootstrap_season_stamps", BootstrapSeasonStampsReducer),
  __reducerSchema("bootstrap_sim_schedules", BootstrapSimSchedulesReducer),
  __reducerSchema("bootstrap_weather", BootstrapWeatherReducer),
  __reducerSchema("bootstrap_world_events", BootstrapWorldEventsReducer),
  __reducerSchema("bump_cloud_money", BumpCloudMoneyReducer),
  __reducerSchema("bump_dishware_pool", BumpDishwarePoolReducer),
  __reducerSchema("bump_pantry_stock", BumpPantryStockReducer),
  __reducerSchema("bus_seat", BusSeatReducer),
  __reducerSchema("cancel_recipe_upgrade", CancelRecipeUpgradeReducer),
  __reducerSchema("cancel_ticket", CancelTicketReducer),
  __reducerSchema("charge_rent", ChargeRentReducer),
  __reducerSchema("claim_achievement", ClaimAchievementReducer),
  __reducerSchema("claim_building", ClaimBuildingReducer),
  __reducerSchema("claim_daily_goal", ClaimDailyGoalReducer),
  __reducerSchema("claim_dirty_pile", ClaimDirtyPileReducer),
  __reducerSchema("claim_low_balance_grant", ClaimLowBalanceGrantReducer),
  __reducerSchema("claim_recycle", ClaimRecycleReducer),
  __reducerSchema("claim_starter_grant", ClaimStarterGrantReducer),
  __reducerSchema("claim_supply_crate", ClaimSupplyCrateReducer),
  __reducerSchema("claim_ticket", ClaimTicketReducer),
  __reducerSchema("claim_tip_bonus", ClaimTipBonusReducer),
  __reducerSchema("clear_waiter_rest_spot", ClearWaiterRestSpotReducer),
  __reducerSchema("collect_clue", CollectClueReducer),
  __reducerSchema("consume_pending_day_advancement", ConsumePendingDayAdvancementReducer),
  __reducerSchema("consume_pending_recipe_upgrades", ConsumePendingRecipeUpgradesReducer),
  __reducerSchema("consume_pending_restock_cost", ConsumePendingRestockCostReducer),
  __reducerSchema("consume_pending_salary", ConsumePendingSalaryReducer),
  __reducerSchema("consume_pending_training_completions", ConsumePendingTrainingCompletionsReducer),
  __reducerSchema("consume_pending_visit_rollup", ConsumePendingVisitRollupReducer),
  __reducerSchema("create_restaurant", CreateRestaurantReducer),
  __reducerSchema("delete_guestbook_entry", DeleteGuestbookEntryReducer),
  __reducerSchema("delete_hired_staff_member", DeleteHiredStaffMemberReducer),
  __reducerSchema("delete_layout_preset", DeleteLayoutPresetReducer),
  __reducerSchema("delete_restaurant", DeleteRestaurantReducer),
  __reducerSchema("deliver_ticket", DeliverTicketReducer),
  __reducerSchema("finish_cooking", FinishCookingReducer),
  __reducerSchema("greet_guest", GreetGuestReducer),
  __reducerSchema("invite_co_owner", InviteCoOwnerReducer),
  __reducerSchema("login", LoginReducer),
  __reducerSchema("logout", LogoutReducer),
  __reducerSchema("mark_guest_dishes_settled", MarkGuestDishesSettledReducer),
  __reducerSchema("mark_guest_leaving", MarkGuestLeavingReducer),
  __reducerSchema("move_furniture", MoveFurnitureReducer),
  __reducerSchema("pickup_dirty_pile", PickupDirtyPileReducer),
  __reducerSchema("pickup_dirty_pile_by_seat", PickupDirtyPileBySeatReducer),
  __reducerSchema("pickup_ticket", PickupTicketReducer),
  __reducerSchema("ping_presence", PingPresenceReducer),
  __reducerSchema("place_from_inventory", PlaceFromInventoryReducer),
  __reducerSchema("place_furniture", PlaceFurnitureReducer),
  __reducerSchema("place_order", PlaceOrderReducer),
  __reducerSchema("process_season_reset", ProcessSeasonResetReducer),
  __reducerSchema("publish_player_save", PublishPlayerSaveReducer),
  __reducerSchema("react_to_restaurant", ReactToRestaurantReducer),
  __reducerSchema("record_visit", RecordVisitReducer),
  __reducerSchema("refresh_neighborhood", RefreshNeighborhoodReducer),
  __reducerSchema("register_staff_actor", RegisterStaffActorReducer),
  __reducerSchema("release_dirty_pile", ReleaseDirtyPileReducer),
  __reducerSchema("remove_co_owner", RemoveCoOwnerReducer),
  __reducerSchema("remove_favorite", RemoveFavoriteReducer),
  __reducerSchema("replace_seat_slots", ReplaceSeatSlotsReducer),
  __reducerSchema("request_password_reset", RequestPasswordResetReducer),
  __reducerSchema("reset_salary_tick_clock", ResetSalaryTickClockReducer),
  __reducerSchema("reset_sim_schedules", ResetSimSchedulesReducer),
  __reducerSchema("respond_friend_request", RespondFriendRequestReducer),
  __reducerSchema("review_restaurant", ReviewRestaurantReducer),
  __reducerSchema("save_account", SaveAccountReducer),
  __reducerSchema("save_layout_preset", SaveLayoutPresetReducer),
  __reducerSchema("save_restaurant_snapshot", SaveRestaurantSnapshotReducer),
  __reducerSchema("sell_dishware", SellDishwareReducer),
  __reducerSchema("sell_furniture", SellFurnitureReducer),
  __reducerSchema("sell_pantry_stock", SellPantryStockReducer),
  __reducerSchema("send_chat_global", SendChatGlobalReducer),
  __reducerSchema("send_chat_private", SendChatPrivateReducer),
  __reducerSchema("send_friend_request", SendFriendRequestReducer),
  __reducerSchema("set_active_menu", SetActiveMenuReducer),
  __reducerSchema("set_auto_shop_enabled", SetAutoShopEnabledReducer),
  __reducerSchema("set_boost_expires_at", SetBoostExpiresAtReducer),
  __reducerSchema("set_cloud_day_history", SetCloudDayHistoryReducer),
  __reducerSchema("set_cloud_money", SetCloudMoneyReducer),
  __reducerSchema("set_cloud_payroll_rate", SetCloudPayrollRateReducer),
  __reducerSchema("set_cloud_rating_history", SetCloudRatingHistoryReducer),
  __reducerSchema("set_cloud_transaction_log", SetCloudTransactionLogReducer),
  __reducerSchema("set_customer_archetype", SetCustomerArchetypeReducer),
  __reducerSchema("set_errand_state", SetErrandStateReducer),
  __reducerSchema("set_furniture_cost", SetFurnitureCostReducer),
  __reducerSchema("set_furniture_meta", SetFurnitureMetaReducer),
  __reducerSchema("set_guest_order", SetGuestOrderReducer),
  __reducerSchema("set_guest_reserved_tiers", SetGuestReservedTiersReducer),
  __reducerSchema("set_guest_waiting_chair", SetGuestWaitingChairReducer),
  __reducerSchema("set_hired_staff_member", SetHiredStaffMemberReducer),
  __reducerSchema("set_ingredient_cost", SetIngredientCostReducer),
  __reducerSchema("set_member_training_deadline", SetMemberTrainingDeadlineReducer),
  __reducerSchema("set_money_cutover_active", SetMoneyCutoverActiveReducer),
  __reducerSchema("set_pantry_target", SetPantryTargetReducer),
  __reducerSchema("set_player_name", SetPlayerNameReducer),
  __reducerSchema("set_prepared_serving", SetPreparedServingReducer),
  __reducerSchema("set_recipe_ingredients", SetRecipeIngredientsReducer),
  __reducerSchema("set_recipe_level", SetRecipeLevelReducer),
  __reducerSchema("set_recipe_meta", SetRecipeMetaReducer),
  __reducerSchema("set_restaurant_name", SetRestaurantNameReducer),
  __reducerSchema("set_restaurant_public", SetRestaurantPublicReducer),
  __reducerSchema("set_restaurant_sign_style", SetRestaurantSignStyleReducer),
  __reducerSchema("set_restaurant_theme_overrides", SetRestaurantThemeOverridesReducer),
  __reducerSchema("set_waiter_rest_spot", SetWaiterRestSpotReducer),
  __reducerSchema("sign_guestbook", SignGuestbookReducer),
  __reducerSchema("sign_up", SignUpReducer),
  __reducerSchema("spawn_guest", SpawnGuestReducer),
  __reducerSchema("start_recipe_upgrade", StartRecipeUpgradeReducer),
  __reducerSchema("stir_ticket", StirTicketReducer),
  __reducerSchema("store_furniture", StoreFurnitureReducer),
  __reducerSchema("submit_feedback", SubmitFeedbackReducer),
  __reducerSchema("submit_leaderboard", SubmitLeaderboardReducer),
  __reducerSchema("sync_cloud_daily_totals", SyncCloudDailyTotalsReducer),
  __reducerSchema("sync_day_clock", SyncDayClockReducer),
  __reducerSchema("unfriend", UnfriendReducer),
  __reducerSchema("unlock_achievement", UnlockAchievementReducer),
  __reducerSchema("unregister_staff_actor", UnregisterStaffActorReducer),
  __reducerSchema("update_dishware_pool", UpdateDishwarePoolReducer),
  __reducerSchema("update_dishwasher_batch", UpdateDishwasherBatchReducer),
  __reducerSchema("update_guest_position", UpdateGuestPositionReducer),
  __reducerSchema("update_restaurant_aggregates", UpdateRestaurantAggregatesReducer),
  __reducerSchema("update_staff_actor", UpdateStaffActorReducer),
  __reducerSchema("wipe_my_restaurant", WipeMyRestaurantReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.3.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

